module.exports = {
    backHost: process && process.env.REACT_APP_HOST_BACK,
    secretApiKey: process && process.env.REACT_APP_SECRET_API_KEY
}